import types from '../types';

const users = (
  state = { loading: true, failure: false, data: null },
  { type, payload },
) => {
  switch (type) {
    case types.GET_USERS_START:
      return { ...state, loading: true, failure: false };

    case types.GET_USERS_SUCCESS:
      return { data: payload, loading: false, failure: false };

    case types.GET_USERS_FAILURE:
      return { ...state, loading: false, failure: true };

    case types.BLOCK_USER_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          data: state.data.data.map(user =>
            user.id === payload.id
              ? { ...user, blocked: payload.data.blocked }
              : user,
          ),
        },
      };

    case types.DELETE_USER_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          data: state.data.data.filter(user => user.id !== payload),
        },
      };

    case types.BLOCK_USER_FAILURE:
    case types.BLOCK_USER_START:
    case types.DELETE_USER_FAILURE:
    case types.DELETE_USER_START:
      return state;

    default:
      return state;
  }
};

export default users;
